import { has, have } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if ([undefined, "draft", "reEdit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCustoms" })) {
                if (["waitReceiveCustoms", "waitDocCustoms"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCenter" })) {
                if (["waitApproveCenter"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forOfficeRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (have({ menuContext, keys: ["forCustoms", "forCenter"] })) {
                    if (["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refRequestType",
                    "refUserCommitteeTemp.refTitle",
                    "refUserCommitteeTemp.firstNameTh",
                    "refUserCommitteeTemp.middleNameTh",
                    "refUserCommitteeTemp.lastNameTh",
                    "refUserCommitteeTemp.fullNameTh",
                    "refUserCommitteeTemp.firstNameEn",
                    "refUserCommitteeTemp.middleNameEn",
                    "refUserCommitteeTemp.lastNameEn",
                    "refUserCommitteeTemp.fullNameEn",
                    "refUserCommitteeTemp.addresses.0.noTh",
                    "refUserCommitteeTemp.addresses.0.noEn",
                    "refUserCommitteeTemp.addresses.0.roomTh",
                    "refUserCommitteeTemp.addresses.0.roomEn",
                    "refUserCommitteeTemp.addresses.0.buildingTh",
                    "refUserCommitteeTemp.addresses.0.buildingEn",
                    "refUserCommitteeTemp.addresses.0.floorTh",
                    "refUserCommitteeTemp.addresses.0.floorEn",
                    "refUserCommitteeTemp.addresses.0.villageTh",
                    "refUserCommitteeTemp.addresses.0.villageEn",
                    "refUserCommitteeTemp.addresses.0.mooTh",
                    "refUserCommitteeTemp.addresses.0.mooEn",
                    "refUserCommitteeTemp.addresses.0.soiTh",
                    "refUserCommitteeTemp.addresses.0.soiEn",
                    "refUserCommitteeTemp.addresses.0.roadTh",
                    "refUserCommitteeTemp.addresses.0.roadEn",
                    "refUserCommitteeTemp.addresses.0.refProvince",
                    "refUserCommitteeTemp.addresses.0.refAmphur",
                    "refUserCommitteeTemp.addresses.0.refTambon",
                    "refUserCommitteeTemp.addresses.0.postCode"
                ].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserCommittee"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserCommitteeTemp.refDocumentTypePerson",
                    "refUserCommitteeTemp.refIssuedBy",
                    "refUserCommitteeTemp.outDate",
                    "refUserCommitteeTemp.expireDate",
                    "refUserCommitteeTemp.birthDate",
                    "refUserCommitteeTemp.refNationality",
                    "refUserCommitteeTemp.refRace",
                    "refUserCommitteeTemp.refReligion",
                    "refUserCommitteeTemp.refGender",
                    "refUserCommitteeTemp.mobile",
                    "refUserCommitteeTemp.fax",
                    "refUserCommitteeTemp.email"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        if (modelRef.refRequestType?.key === "1") {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserCommitteeTemp.idCard"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                let suffix = undefined;
                if (has({ menuContext, key: "forRequest" })) {
                    suffix = null;
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        if (modelRef.refRequestType?.key === "1") {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                if (has({ menuContext, key: "forCustoms" })) {
                    suffix = null;
                }
                return { disabled: !enabled, suffix };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserCommitteeTemp.addresses.0.refAddressType"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserCommitteeTemp.addresses.0.tel",
                    "refUserCommitteeTemp.addresses.0.fax",
                    "refUserCommitteeTemp.addresses.0.latitude",
                    "refUserCommitteeTemp.addresses.0.longitude",
                    "refUserCommitteeTemp.addresses.0.map"
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return ["refUserCommitteeTemp.buttonCheckIdCard"].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (has({ menuContext, key: "forCenter" })) {
                    if (["waitApproveCenter"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                return result;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                let canCreate = false;
                let canDelete = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                        canCreate = !viewOnly || canCreate;
                        canDelete = !viewOnly || canDelete;
                    }
                }
                return { viewOnly: !enabled, canCreate, canDelete };
            }
        }
    ];
};
